import React from "react";
import { Link } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";
import { Hexagon, Layers, Lock, GitBranch, Workflow, Database, ArrowRight } from "lucide-react";

const DEFI_IMG = "https://static.prod-images.emergentagent.com/jobs/d5947c87-469b-453f-bcc8-696560810837/images/728ac60a373759880dc19989442eed4e227dddfa3aaaac7ae146b335ddd64786.png";

export default function DefiArchitecture() {
  return (
    <div className="bg-cosmos text-white" data-testid="defi-page">
      <MarketingNav />

      <section className="relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <div className="font-mono-fin text-xs uppercase tracking-widest text-cyan-400 mb-3">Arquitectura</div>
            <h1 className="font-display font-bold text-5xl md:text-6xl tracking-tighter text-white leading-[0.95]">
              Bancario por fuera.<br/>
              <span className="brand-text-light">DeFi-ready</span> por dentro.
            </h1>
            <p className="text-white/70 text-lg mt-5 max-w-xl leading-relaxed">
              OpenPayments combina una capa regulada con una capa criptográfica conceptual que sella cada operación.
            </p>
          </div>
          <div className="lg:col-span-6">
            <div className="aspect-square rounded-3xl overflow-hidden border border-white/10 bg-white/5">
              <img src={DEFI_IMG} alt="DeFi architecture" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="border-y border-white/10 py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="font-mono-fin text-xs uppercase tracking-widest text-cyan-400 mb-3">Capas</div>
          <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tighter text-white mb-12">Stack en 5 capas</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden">
            {[
              { i: Layers, t: "Interfaz", d: "React + paneles de control. Datos en tiempo real." },
              { i: Workflow, t: "Aplicación", d: "FastAPI · ISO 20022 · gestión de transferencias." },
              { i: Lock,    t: "Seguridad", d: "JWT · bcrypt · SCA · auditoría inmutable." },
              { i: Database,t: "Liquidación", d: "MongoDB · cuentas, IBAN, libro mayor." },
              { i: GitBranch,t: "Criptografía", d: "SHA-256 · firma de documentos." },
            ].map(({ i: I, t, d }, idx) => (
              <div key={idx} className="bg-slate-950/60 backdrop-blur p-8">
                <div className="font-mono-fin text-xs text-white/50">0{idx + 1}</div>
                <I size={22} className="text-cyan-400 mt-3" />
                <div className="font-display font-bold text-xl text-white mt-4">{t}</div>
                <div className="text-white/65 text-sm mt-2">{d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <h3 className="font-display font-bold text-3xl tracking-tighter text-white">¿Qué firmamos?</h3>
          </div>
          <div className="lg:col-span-7 space-y-4 text-white/75">
            <div className="border border-white/15 rounded-2xl p-5 bg-white/5">
              <div className="flex items-center gap-2 text-white"><Hexagon size={14} className="text-cyan-400" /> <b>Certificados de cuenta</b></div>
              <p className="text-sm text-white/60 mt-2">Cada PDF incluye un hash único derivado de IBAN + titular + fecha.</p>
            </div>
            <div className="border border-white/15 rounded-2xl p-5 bg-white/5">
              <div className="flex items-center gap-2 text-white"><Hexagon size={14} className="text-cyan-400" /> <b>Comprobantes de movimiento</b></div>
              <p className="text-sm text-white/60 mt-2">Sello criptográfico por transacción · verificable.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="border-t border-white/10 py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col items-start">
          <h3 className="font-display font-bold text-4xl md:text-5xl tracking-tighter text-white max-w-3xl">
            Probá la arquitectura. Abrí tu cuenta y descargá un comprobante firmado.
          </h3>
          <Link to="/registro" className="btn-primary mt-8" data-testid="defi-cta-register">
            Crear cuenta <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
